export default __webpack_public_path__ + "static/media/logo_brocker_turismo_svg.8e3f4339.svg";